<template>
    <div>
        <div class="task-prop">
            <strong>Теги:</strong>

            <label v-if="!tagsOnly" class="form-input--group task-prop__value">
                <input
                    type="text"
                    class="form-input"
                    :disabled="disabled"
                    v-model.trim="currentTag"
                    @keydown.enter="insertTag"
                >
                <button type="button" class="btn btn-primary ml-1"
                v-if="!disabled"
                    id="plus"
                    title="Добавить тег"
                    @click="insertTag"
                >Добавить тег</button>
            </label>
        </div>
        <Scroll class="tags" style="width: 100%;max-height: 56px">
            <div class="tag text-icon" v-for="tag in tags">
                <span class="text ellipsis">{{ tag.name }}</span>
                <Icon v-if="!disabled" id="delete" style="--size: 14px" @click="deleteTag(tag.id || tag.tmpId)"></Icon>
            </div>
        </Scroll>
    </div>
</template>

<script>
import {validateTag} from "@/vue/plan/validation";
import {tmpId} from "@common/utils/text";

export default {
    name: "Tags",
    props: ['tags', 'tagsOnly', 'disabled'],
    data() {
        return {
            currentTag: '',
        }
    },
    methods: {
        insertTag() {
            if (!this.isEmpty() && !this.isAlreadyExists()) {
                const newTag = {
                    tmpId: tmpId(),
                    name: this.currentTag,
                };

                this.$emit('insert', newTag);
                this.$emit('update', [...this.tags, validateTag(newTag)]);
            }

            this.currentTag = '';
        },
        deleteTag(tagId) {
            this.$emit('delete', tagId);
            this.$emit('update', this.tags.filter(tag => {
                if (tag.id) return tag.id !== tagId;
                return tag.tmpId !== tagId;
            }));
        },
        isEmpty() {
            return 0 === this.currentTag.length;
        },
        isAlreadyExists() {
            return this.tags.map(v => v.name).includes(this.currentTag);
        }
    }
}
</script>

<style lang="scss" scoped>
.tag {
    & .text {
        color: #212529;
    }
}
</style>
